import http from '@/api/http'
import { protectedRequest } from '@/api/protectedRequest'
import { API_BASE_URL } from '@/config/env'
import { mapFinanceSummary } from '@/entities/finance/model/mapFinance'

export const FINANCE_MOBILE_PAGE_SIZE = 3
export const FINANCE_DESKTOP_PAGE_SIZE = 5

function hasFinanceApi() {
  return Boolean(API_BASE_URL)
}

function unwrapFinancePayload(body) {
  const payload = body?.data ?? body
  const total = Number(body?.total ?? payload?.total) || 0
  return { payload, total }
}

export async function fetchRestaurantFinanceApi({
  skip = 0,
  limit = FINANCE_MOBILE_PAGE_SIZE,
} = {}) {
  if (!hasFinanceApi()) {
    return mapFinanceSummary(null)
  }

  const body = await protectedRequest(() =>
    http.get('/restaurant/finance', {
      params: {
        skip: Math.max(0, Number(skip) || 0),
        limit: Math.max(1, Number(limit) || FINANCE_MOBILE_PAGE_SIZE),
      },
    }),
  )
  const { payload, total } = unwrapFinancePayload(body)
  return mapFinanceSummary(payload, { total })
}

export async function fetchCourierFinanceApi({
  skip = 0,
  limit = FINANCE_MOBILE_PAGE_SIZE,
} = {}) {
  if (!hasFinanceApi()) {
    return mapFinanceSummary(null)
  }

  const body = await protectedRequest(() =>
    http.get('/courier/finance', {
      params: {
        skip: Math.max(0, Number(skip) || 0),
        limit: Math.max(1, Number(limit) || FINANCE_MOBILE_PAGE_SIZE),
      },
    }),
  )
  const { payload, total } = unwrapFinancePayload(body)
  return mapFinanceSummary(payload, { total })
}

export async function fetchFinanceSummaryApi(role, options) {
  if (role === 'courier') {
    return fetchCourierFinanceApi(options)
  }
  return fetchRestaurantFinanceApi(options)
}
